import { keepPreviousData, useQuery } from '@tanstack/react-query';

import {
  type TextChunks,
  type TextChunksQuery,
  TextChunksSchema,
} from '@mai/types';

import { apiClient } from './axios';

import { logger } from '@utils/logger';

export const TEXT_CHUNKS_QUERY_KEY = 'text-chunks';

export const useTextChunksQuery = (
  params: TextChunksQuery,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: [TEXT_CHUNKS_QUERY_KEY, params],
    queryFn: async () => {
      const response = await apiClient.get<TextChunks>('/text-chunks', {
        params,
      });
      const validatedData = TextChunksSchema.safeParse(response.data);
      if (!validatedData.success) {
        logger.warn('failed to validate text chunks data', {
          error: validatedData.error,
        });
        return response.data;
      }

      return validatedData.data;
    },
    enabled,
    placeholderData: keepPreviousData,
  });
};
